import Vue from 'vue'
import VueRouter from 'vue-router'
import Index from '../views/index.vue'
import Login from '../login.vue'
import before from './before.js'
import Core from '@/libs/src/core'
Vue.use(VueRouter)

const routes = [
  {
    path: '/login',
    name: 'login',
    component: Login,
    meta: {
      title: '登陆',
    },
  },
  {
    path: '/',
    name: 'home',
    component: Index,
    meta: {
      title: '合续环境综合管理平台',
    },
  },
  {
    path: '*',
    name: '404',
    component:Index
  },
]

const router = new VueRouter({
  // mode: 'history',
  base: process.env.BASE_URL,
  routes
})
before(router)

Core.setData({
 VueRouter:router
})

export default router
